import React from "react";
import dynamic from "next/dynamic";

const HeaderComponent = dynamic(() => import("../containers/Header"));
const FooterComponent = dynamic(() => import("../containers/Footer"));

export default function Layout({ children }) {
  return (
    <React.Fragment>
      <HeaderComponent
        key="header"
        trackId={
          children["props"]["data"]?.trackid ||
          children["props"]["data"]?.trackId
        }
      />
      {children}
      <FooterComponent key="footer" />
    </React.Fragment>
  );
}
